module.exports = __webpack_public_path__ + "img/home-top.c31e92ec.jpg";